"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.acl = acl;
const backendImport_1 = require("@front/backendImport");
const component_1 = require("@front/layouts/default-layout/component");
function acl(aclString, templateOrTemplateBinding) {
    const getTemplate = typeof templateOrTemplateBinding === 'function'
        ? templateOrTemplateBinding
        : () => templateOrTemplateBinding;
    return (source, context) => {
        if (aclString && typeof aclString !== 'string') {
            aclString = aclString(source, context);
        }
        if (!aclString) {
            return getTemplate(source, context);
        }
        const user = component_1.DefaultLayout.USER;
        if (!user) {
            return null;
        }
        if (user.role === backendImport_1.UserRoles.SUPER_ADMIN) {
            return getTemplate(source, context);
        }
        const aclPolicy = user.acl;
        if (!aclPolicy) {
            // If user is a standard user with no ACL policy, allow basic read operations
            if (user.role === backendImport_1.UserRoles.USER && typeof aclString === 'string') {
                const [resource, action] = aclString.split('.');
                if (action === 'read') {
                    // Allow read access to basic resources
                    const allowedResources = ['avatar', 'ai', 'knowledge', 'project', 'profession', 'branch', 'step', 'question', 'answer', 'onboarding'];
                    return allowedResources.includes(resource) ? getTemplate(source, context) : null;
                }
            }
            console.warn(`No ACL policy found for user ${user.id}`);
            return null;
        }
        return backendImport_1.ACL.checkACL(aclString, aclPolicy) ? getTemplate(source, context) : null;
    };
}
